import { apiWobaBackend } from "@/services/api-woba-backend";
import { apiWobaInventory } from "@/services/api-woba-inventory";

export const amenitiesService = {
  async getAmenities() {
    const { data } = await apiWobaBackend.get(`/amenities`);

    return data;
  },

  async getInventoryAmenities() {
    const { data } = await apiWobaInventory.get("/amenities");
    return data;
  },
};
